import { useContext } from "react";
import {
  NotificationContext,
  NotificationContextType,
} from "../context/Notification";

export default function useNotification(): NotificationContextType {
  return useContext(NotificationContext);
}
